import { Reveal } from "@/components/motion/Reveal";
import { Shield, BookCheck, Rocket } from "lucide-react";

const cols = [
  {
    icon: Shield,
    title: "Deliverability + compliance",
    body: "94% Primary-tab placement across Gmail, Outlook & Yahoo. RFC-8058 unsubscribe headers. Auto-throttle below 80%.",
  },
  {
    icon: BookCheck,
    title: "Data accuracy",
    body: "Grounded in your site and approved assets. AI never invents facts or collateral.",
  },
  {
    icon: Rocket,
    title: "Onboarding + ramp",
    body: "Live in under 2 minutes. First qualified meeting free. Cancel anytime.",
  },
];

export function TrustCompressed() {
  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 py-20 md:py-28">
        <Reveal stagger={60} className="text-center space-y-3 max-w-2xl mx-auto mb-12">
          <p className="text-[10px] font-mono uppercase tracking-widest text-foreground/80">
            Built for serious senders
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground tracking-tight">
            Safe, accurate, ready in minutes.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cols.map((c, i) => (
            <Reveal key={c.title} delay={i * 90}>
              <div className="h-full rounded-xl border border-border/60 bg-background/70 backdrop-blur-xl p-6 hover:border-primary/40 transition-colors">
                <c.icon className="h-5 w-5 text-primary mb-4" />
                <h3 className="text-base font-semibold text-foreground mb-2">{c.title}</h3>
                <p className="text-sm text-foreground/75 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
